import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss']
})
export class PublicHeaderComponent implements OnInit {

  allLabelsForGlobalTopNav: any
  planManagerDropdownClick: boolean = false
  serverPath ="/dcrkpublic/assets/vanguard-logo.svg"
  localPath ='assets/vanguard-logo.svg'
  env = environment.PRODUCTION
  constructor(
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.commonService.getLabelsForGlobalMenus().subscribe((res)=>{
      this.allLabelsForGlobalTopNav=res.menus['global-top-navigation-menu']
    })

  }

}
